import _regeneratorRuntime from "@babel/runtime/regenerator";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import fs from 'fs';
import Headers from './headers.node';
import { readFile, createReadStream } from './read-file.node';

var isDataURL = function isDataURL(url) {
  return url.startsWith('data:');
};

var isRequestURL = function isRequestURL(url) {
  return url.startsWith('http:') || url.startsWith('https:');
};

var NodeFetchResponse = function () {
  function NodeFetchResponse(url, options) {
    _classCallCheck(this, NodeFetchResponse);

    this._url = url;
    this._ok = true;
    this._status = 200;
    this.options = options;
    this.bodyUsed = false;
    this._headers = null;
  }

  _createClass(NodeFetchResponse, [{
    key: "arrayBuffer",
    value: function () {
      var _arrayBuffer = _asyncToGenerator(_regeneratorRuntime.mark(function _callee() {
        var data;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                this.bodyUsed = true;
                _context.next = 3;
                return readFile(this.url, this.options);

              case 3:
                data = _context.sent;
                return _context.abrupt("return", data);

              case 5:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function arrayBuffer() {
        return _arrayBuffer.apply(this, arguments);
      }

      return arrayBuffer;
    }()
  }, {
    key: "text",
    value: function () {
      var _text = _asyncToGenerator(_regeneratorRuntime.mark(function _callee2() {
        var arrayBuffer, textDecoder;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return this.arrayBuffer();

              case 2:
                arrayBuffer = _context2.sent;
                textDecoder = new TextDecoder();
                return _context2.abrupt("return", textDecoder.decode(arrayBuffer));

              case 5:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function text() {
        return _text.apply(this, arguments);
      }

      return text;
    }()
  }, {
    key: "json",
    value: function () {
      var _json = _asyncToGenerator(_regeneratorRuntime.mark(function _callee3() {
        var text;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return this.text();

              case 2:
                text = _context3.sent;
                return _context3.abrupt("return", JSON.parse(text));

              case 4:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function json() {
        return _json.apply(this, arguments);
      }

      return json;
    }()
  }, {
    key: "_getHeaders",
    value: function _getHeaders() {
      var headers = {};

      if (this.httpResponse) {
        var httpHeaders = this.httpResponse.getHeaders();

        for (var name in httpHeaders) {
          var header = headers[name];
          headers[name] = String(header);
        }
      } else {
        var contentLength = this._getContentLength();

        if (Number.isFinite(contentLength)) {
          headers['Content-Length'] = contentLength;
        }
      }

      return new Headers(headers);
    }
  }, {
    key: "_getContentLength",
    value: function _getContentLength() {
      if (isRequestURL(this.url)) {
        return null;
      } else if (isDataURL(this.url)) {
        return this.url.length - 'data:'.length;
      }

      var stats = fs.statSync(this.url);
      return stats.size;
    }
  }, {
    key: "ok",
    get: function get() {
      return this._ok;
    }
  }, {
    key: "status",
    get: function get() {
      return this._status;
    }
  }, {
    key: "url",
    get: function get() {
      return this._url;
    }
  }, {
    key: "headers",
    get: function get() {
      this._headers = this._headers || this._getHeaders();
      return this._headers;
    }
  }, {
    key: "body",
    get: function get() {
      var url = this.url,
          options = this.options;
      this.bodyUsed = true;
      return createReadStream(url, options);
    }
  }]);

  return NodeFetchResponse;
}();

export { NodeFetchResponse as default };
//# sourceMappingURL=response.node.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@loaders.gl/polyfills/dist/esm/fetch-node/response.node.js
// module id = 353
// module chunks = 0